import { Component, OnInit, OnDestroy, effect, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/auth.service';
import { ModelsDialogComponent } from 'src/app/shared/components/models-dialog/models-dialog.component';
import { ConfirmMenuService } from 'src/app/shared/services/confirm-menu/confirm-menu.service';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { ModelsService } from './models.service';

@Component({
  selector: 'app-my-models',
  templateUrl: './my-models.component.html',
  styleUrls: ['./my-models.component.scss'],
  standalone: false,
})
export class MyModelsComponent implements OnInit, OnDestroy {
  public sidenavService = inject(SidenavService);
  public isSmallScreen = this.sidenavService.isSmallOrTablet;

  private toggleEffect = effect(() => {
    const isSmall = this.isSmallScreen();
    this.sidenavService.showGlobalToggle.set(!isSmall);
  });

  templates = [];
  displayedTemplates = [];
  loading = false;
  searchTerm = '';
  pageIndex = 0;
  totalSize;
  pageSizeOptions = [10, 20, 30, 40, 50];
  pageSize = this.pageSizeOptions[0];
  expandedId: string | null = null;

  constructor(
    private modelService: ModelsService,
    private router: Router,
    private confirmMenuService: ConfirmMenuService,
    private translate: TranslateService,
    private dialog: MatDialog,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.getTemplates();
  }

  ngOnDestroy(): void {
    this.sidenavService.showGlobalToggle.set(true);
  }

  onPageChange(event) {
    this.pageIndex = event.page;
    this.pageSize = event.pageSize;
    this.getTemplates();
  }

  getTemplates() {
    this.loading = true;
    this.modelService
      .searchTemplates({
        searchTerm: this.searchTerm,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      })
      .subscribe({
        next: (res) => {
          this.templates = res.results || [];
          this.totalSize = res.totalCount || 0;
          this.filter();
          this.loading = false;
        },
        error: (err) => {
          console.error(err);
          this.loading = false;
        },
      });
  }

  openTemplate(template) {
    this.router.navigate(['myspace', 'my-models', template._id]);
  }

  filter() {
    this.displayedTemplates = this.templates.filter((template) => template.name.includes(this.searchTerm)) || [];
  }

  toggleExpand(id: string) {
    this.expandedId = this.expandedId === id ? null : id;
  }

  createTemplate() {
    this.dialog
      .open(ModelsDialogComponent, {
        width: '90vw',
        maxWidth: '800px',
        data: { type: 'create' },
        disableClose: true,
        autoFocus: false,
      })
      .afterClosed()
      .subscribe({
        next: (res) => {
          if (res) {
            this.getTemplates();
          }
        },
        error: (err) => {
          console.error(err);
        },
      });
  }

  userIsNotReader() {
    const userInfo = this.authService.userInfo();
    return userInfo.type == 'Writer' || userInfo.type == 'Admin';
  }

  deleteTemplate(template, event: MouseEvent) {
    const target = event.currentTarget as HTMLElement;
    this.confirmMenuService.confirm(target, this.translate.instant('Global.Delete'), 'delete_outline', '#ef4444').subscribe(() => {
      this.loading = true;
      this.modelService.deleteTemplate(template._id).subscribe({
        next: () => {
          this.getTemplates();
        },
        error: (err) => {
          console.error(err);
          this.loading = false;
        },
      });
    });
  }
}
